import React from "react";
import { Box } from "@mui/system";
import { Controller } from "react-hook-form";
import { SubmitButton } from "../../components/form";
import { Grid } from "@mui/material";
import OutlinedInputComponent from "components/form/outlined-input/OutlinedInput.component";
import { gridSpacing } from "constants/theme"; import { useTranslation } from "react-i18next";

const UpdateProfileForm = ({
  errors,
  control,
  isSubmitting = false,
  handleSubmit = () => { },
  labelButton = "Aggiungi",
}) => {
  const { t } = useTranslation()
  return (
    <Box component="form" noValidate onSubmit={handleSubmit} width={1}>
      <Grid container spacing={gridSpacing}>
        <Grid item xs={12} sm={12}>
          <Controller
            name="email"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <OutlinedInputComponent
                error={errors?.email}
                required={true}
                label="Email*"
                {...field}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="firstName"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <OutlinedInputComponent
                error={errors?.name}
                required={false}
                label={t('Name')}
                {...field}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <Controller
            name="lastName"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <OutlinedInputComponent
                error={errors?.lastName}
                required={false}
                label={t('Last name')}
                {...field}
              />
            )}
          />
        </Grid>


        <Grid item xs={12} sm={12}>
          <SubmitButton label={labelButton} isSubmitting={isSubmitting} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default UpdateProfileForm;
